/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { addTransparency } from '@btime/helpers'
import { css } from '@emotion/react'
import React from 'react'

import { SmallText } from '../presentation/Text'
import Center from './Center'
import Link from '../actions/Link'

const Expandable = ({ children, height, bgColor, disabled }) => {
  const [open, setOpen] = React.useState(disabled)
  bgColor = bgColor || COLORS.white
  const style = css`
    position: relative;
    ${!open ? `height: ${height || '20rem'};` : ''}
    ${!open ? `overflow-y: hidden;` : ''}
		& > .loadMoreWrapper {
      padding-top: 2rem;
      padding-bottom: 0.5rem;
      ${open ? `display: none;` : ''}
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      background-image: linear-gradient(${addTransparency(bgColor, 0)}, ${addTransparency(bgColor, 0.7)}, ${bgColor});
    }
  `

  return (
    <div className="expandable" css={style}>
      {children}
      <div className="loadMoreWrapper">
        <Center>
          <Link block onClick={() => setOpen(true)}>
            <SmallText color={COLORS.purple} bold>
              Ver mais
            </SmallText>
          </Link>
        </Center>
      </div>
    </div>
  )
}

export default Expandable
